// URL
import { CARD_LIMIT } from '../Data';
export const URL_GET_OUTLET_WALLET = `/outlet-wallets?_limit=${CARD_LIMIT}%(params)s`;

// Types
export const types = {
    GET_PARTNER_OUTLET_LOADING: 'GET_PARTNER_OUTLET_LOADING',
    GET_PARTNER_OUTLET_SUCCESS: 'GET_PARTNER_OUTLET_SUCCESS',
    GET_PARTNER_OUTLET_FAILED: 'GET_PARTNER_OUTLET_FAILED',
};
